import AdminBrandHeader from "./components/AdminBrandHeader";
import AdminLoginForm from "./components/AdminLoginForm";
const AdminLogin = () => {
    return (<div className="min-h-screen w-full flex items-center justify-center overflow-y-auto relative" style={{
            background: "#0F172A",
            fontFamily: '"Noto Sans KR", sans-serif',
        }}>
      <div className="absolute inset-0 pointer-events-none" style={{
            backgroundImage: "linear-gradient(rgba(59,130,246,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(59,130,246,0.04) 1px, transparent 1px)",
            backgroundSize: "40px 40px",
        }}/>

      <div className="absolute top-0 left-0 w-96 h-96 pointer-events-none" style={{
            background: "radial-gradient(circle at 0% 0%, rgba(59,130,246,0.08) 0%, transparent 70%)",
        }}/>

      <div className="absolute bottom-0 right-0 w-96 h-96 pointer-events-none" style={{
            background: "radial-gradient(circle at 100% 100%, rgba(14,165,233,0.07) 0%, transparent 70%)",
        }}/>

      <div className="absolute top-6 right-6 flex items-center gap-2 px-3 py-1.5 rounded-lg z-10" style={{
            background: "rgba(30,41,59,0.8)",
            border: "1px solid #334155",
        }}>
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" style={{ boxShadow: "0 0 6px rgba(52,211,153,0.6)" }}/>
        <span className="text-xs text-slate-400">시스템 정상</span>
      </div>

      <div className="w-full max-w-sm mx-4 relative z-10">
        <div className="rounded-2xl overflow-hidden" style={{
            background: "#1E293B",
            border: "1px solid #334155",
            boxShadow: "0 24px 64px rgba(0,0,0,0.5), 0 0 0 1px rgba(59,130,246,0.08)",
        }}>
          <div className="h-0.5 w-full" style={{ background: "linear-gradient(90deg, #3B82F6 0%, #0EA5E9 50%, transparent 100%)" }}/>
          <AdminBrandHeader />
          <div className="mx-8 mb-6">
            <div className="h-px" style={{ background: "#334155" }}/>
          </div>
          <AdminLoginForm />
        </div>

        <p className="text-center text-xs text-slate-700 mt-5">Daeul Admin Console</p>
      </div>
    </div>);
};
export default AdminLogin;
